/**
 * Normalize a personal/legal name for the PERSON identity coupling rule —
 * mirror of `normalizePersonalName` in
 * `src/modules/intermediary-onboarding/application/IntermediaryOnboardingService.ts`.
 *
 * The BE enforces equality of `organization.legalName` vs `adminUser.fullName`
 * when `legalNature === PERSON` after this same normalization. The FE
 * runs the same check so the user gets immediate feedback instead of a
 * round-trip 400.
 *
 * Steps: NFC → trim → collapse whitespace → uppercase → tokenize → sort → join.
 * Order-agnostic so "Mario Rossi" and "Rossi Mario" both compare equal.
 */
export function normalizePersonalName(value: string): string {
  return value
    .normalize('NFC')
    .trim()
    .replace(/\s+/g, ' ')
    .toUpperCase()
    .split(' ')
    .filter((token) => token.length > 0)
    .sort()
    .join(' ');
}
